export const MENU = "MENU";

export const menuAction = (payload) => ({
    type: MENU,
    payload
})

